<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field id="prompt-name" v-model="node.name" label="Name" dense>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0">
        <draggable
          class="list-group"
          tag="div"
          v-model="property.bot_says"
          v-bind="dragOptions"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <v-row
              v-for="(element, index) in property.bot_says"
              :key="element.order"
            >
              <v-col
                cols="12"
                sm="12"
                lg="12"
                class="d-flex cursor-pointer align-start m-b-15 p-t-0 p-b-0"
              >
                <prompt-payload
                  :index="index"
                  :prompt="element"
                  :minioHost="minioHost"
                  :imagePaths="imagePaths"
                  :videoPaths="videoPaths"
                  :voicePaths="voicePaths"
                  :ttsChoices="ttsChoices"
                  @isSubPlaying="isSubPlaying"
                  @deletePrompt="deletePrompt"
                  style="width: 100%"
                  :key="element.order"
                  :ttsProperty="drawFlowItems.Home.data['1'].data.property.tts"
                />
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </transition-group>
        </draggable>

        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex pt-0 pb-0">
            <div>
              <v-menu :absolute="true">
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex" v-bind="attrs" v-on="on">
                    <v-icon small class="m-r-5">fa-plus-circle</v-icon>
                    <div>Add output type</div>
                  </div>
                </template>
                <v-list dense>
                  <v-list-item
                    v-for="(option, index) in chatOptions"
                    :key="index"
                    @click="voiceOptionClick(option.action)"
                  >
                    <v-list-item-content>
                      <v-list-item-subtitle
                        :id="`list${index}`"
                        class="font-size-body"
                      >
                        <v-icon small class="width20px m-r-10"
                          >{{ option.icon }} </v-icon
                        >{{ option.title }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />

    <audio ref="myAudio" autoload>
      <source :src="previewVoice" type="audio/wav" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script>
import draggable from '@/plugins/vuedraggable'
import PromptPayload from './payloads/index'
import apiImage from '@/apis/image'
import apiVideo from '@/apis/video'

import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object,
    drawFlowItems: Object
  },
  components: {
    draggable,
    PromptPayload,
    NoteComponent
  },
  data() {
    return {
      property: {},
      rules: {
        required: value => !!value || 'Required.'
      },
      order: 1,
      chatOptions: [
        {
          title: 'Text Message',
          icon: 'fa-comment-dots',
          action: 'text'
        },
        { title: 'Text-to-speech', icon: 'far fa-comment-dots', action: 'tts' },
        { title: 'Variable', icon: 'fa-dollar-sign', action: 'parameter' },
        {
          title: 'Image',
          icon: 'fa-image',
          action: 'image'
        },
        // { title: 'Audio', icon: 'fa-volume-up', action: 'file' },
        { title: 'Video', icon: 'fa-video', action: 'video' },
        { title: 'Carousel', icon: 'mdi-view-carousel', action: 'carousel' },
        { title: 'Button', icon: 'mdi-gesture-tap-button', action: 'button' },
        { title: 'Quick Reply', icon: 'fa fa-reply', action: 'quick_reply' },
        { title: 'Pause', icon: 'fa-ellipsis-h', action: 'pause' }
      ],
      minioHost: '',
      imagePaths: [],
      videoPaths: [],
      voicePaths: [],
      ttsChoices: [],
      playAllVoice: [],
      isPlaying: false,
      isPlayingAll: false,
      indexPlayAll: '',
      previewVoice: ''
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
        filter: '.no-drag',
        preventOnFilter: false
      }
    }
  },
  async created() {
    this.property = this.node.property
    for (let i = 0; i < this.property.bot_says.length; i++) {
      this.order =
        this.order <= this.property.bot_says[i].order
          ? this.property.bot_says[i].order + 1
          : this.order
    }
    await this.initial()
  },
  mounted() {
    this.$refs.myAudio.addEventListener('play', () => {
      this.isPlayingAll = true
    })
    this.$refs.myAudio.addEventListener('ended', () => {
      const total = this.playAllVoice.length
      if (this.indexPlayAll < total) {
        this.previewVoice = this.playAllVoice[this.indexPlayAll]
        this.indexPlayAll += 1
        this.$refs.myAudio.load()
        setTimeout(() => {
          this.$refs.myAudio.play()
        }, 300)
      } else {
        this.indexPlayAll = ''
        this.isPlayingAll = false
      }
    })
  },
  methods: {
    async initial() {
      await this.getImagePath()
      await this.getVoicePath()
      await this.getVideoPath()
    },
    async getImagePath() {
      try {
        this.imagePaths = []
        const getImagePath = await apiImage.getImage()
        const { data } = getImagePath
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj.id = data[i].id || ''
          obj.name = data[i].name || ''
          obj.description = data[i].description || ''
          obj.path = data[i].path || ''
          this.imagePaths.push(obj)
        }
      } catch (error) {}
    },
    async getVideoPath() {
      try {
        this.videoPaths = []
        const getImagePath = await apiVideo.getVideo()
        const { data } = getImagePath
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj.id = data[i].id || ''
          obj.name = data[i].name || ''
          obj.description = data[i].description || ''
          obj.previewImagePath = data[i].previewImagePath || ''
          obj.path = data[i].path || ''
          this.videoPaths.push(obj)
        }
      } catch (error) {}
    },
    async getVoicePath() {
      try {
        this.voicePaths = []
        const getVoicePath = await apiPrompt.getVoicePath()
        const { data } = getVoicePath
        for (let i = 0; i < data.length; i++) {
          const obj = {}
          obj._id = data[i]._id ? data[i]._id : ''
          obj.text = data[i].text ? data[i].text : ''
          obj.path = data[i].path ? data[i].path : ''
          this.voicePaths.push(obj)
        }
      } catch (error) {}
    },
    voiceOptionClick(action) {
      let template = {}
      switch (action) {
        case 'text':
          template = {
            type: 'text',
            text: ''
          }
          break
        case 'tts':
          template = {
            type: 'tts',
            text: '',
            speed: 1,
            pitch: 1
          }
          break
        case 'image':
          template = {
            type: 'image',
            urlType: 'Internal',
            path: '',
            url: ''
          }
          break
        case 'video':
          template = {
            type: 'video',
            path: '',
            previewImagePath: ''
          }
          break
        case 'quick_reply':
          template = {
            type: 'quick_reply',
            payload: {
              message: '',
              buttons: [
                {
                  type: 'text',
                  title: '',
                  payload: ''
                }
              ]
            }
          }
          break
        case 'button':
          template = {
            type: 'button',
            payload: {
              message: '',
              buttons: [
                {
                  type: 'text',
                  title: '',
                  payload: ''
                }
              ]
            }
          }
          break
        case 'carousel':
          template = {
            type: 'carousel',
            isManual: true,
            payloads: [],
            variable: {
              apiResult: '',
              image: '',
              urlLanding: '',
              title: '',
              subtitle: '',
              button: {
                type: 'text',
                title: '',
                payload: ''
              }
            }
          }
          break
        case 'parameter':
          template = {
            type: 'parameter',
            contentType: 'Text',
            say_as: ''
          }
          break
        case 'pause':
          template = {
            type: 'pause',
            value: 0.5
          }
          break
      }
      template.order = this.order
      if (template.type) this.property.bot_says.push(template)
      this.order += 1
    },
    deletePrompt(index) {
      this.property.bot_says.splice(index, 1)
    },
    isSubPlaying() {
      if (this.isPlaying) {
        this.$refs.myAudio.pause()
        this.isPlaying = false
      }
    }
  }
}
</script>

<style scope lang="scss">
.width20px {
  width: 20px;
}
</style>
